import { render } from "./FormInput.vue?vue&type=template&id=b785ecf2"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
script.render = render

export default script